import { render, staticRenderFns } from "./userDashboardTrainingPlans.vue?vue&type=template&id=0da27fb0&scoped=true"
import script from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
export * from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTrainingPlans.vue?vue&type=style&index=0&id=0da27fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da27fb0",
  null
  
)

export default component.exports